module.exports = __webpack_public_path__ + "static/media/Sanjay.02c75123.jpg";